import { User as PBUser } from "gen/user/models_pb"
import { User } from "shared-ts/classes/user"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell/TableCell"
import { DataColumn } from "../useTable/types"

type UserAccessorFn<T> = TypedAccessor<T, PBUser | undefined>
interface UserColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: DataColumn<T>["width"]
}

export type UserColumnHelper<T> = (
  accessorFn: UserAccessorFn<T>,
  col: UserColumn<T>
) => DataColumn<T>

export function user<T>(
  accessorFn: UserAccessorFn<T>,
  col: UserColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const user = accessorFn(rowData)
      if (!user) return null
      return User.fromPB(user).displayName
    },
    width: TableCellWidth.Medium,
    ...col,
  })
}
